'use client';

import {useSetScreenName} from '@web-catalog/store';

import {ScreenName} from '@web-catalog/utils/analytics';

export const ScreenNameSetter = ({screenName}: {screenName: ScreenName}) => {
  useSetScreenName(screenName);

  return null;
};
